// extracted by mini-css-extract-plugin
module.exports = {"plus":"DetailsInputButton_plus__2Sr5H","minus":"DetailsInputButton_minus__2KOg6"};